'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var excludes = [
  'upgrade'
]

/* eslint-env browser */

var storage = require('../../storage')

var notice
var defaultmsg = '';
var defaultMsgMeta = document.getElementById('defaultmessage');
if (defaultMsgMeta) {
  defaultmsg = defaultMsgMeta.content
}
var store = []
var notices = document.getElementById('notices')
var warn = function (msg) { return queue(("<p class=\"m0 p1 bg-red white\">" + (msg || defaultmsg) + "</p>"), true); }
var confirm = function (msg) { return queue(("<p class=\"m0 p1 bg-green white\">" + msg + "</p>"), true); }

var queue = function (data, prepend) { return (
  store[ prepend ? 'unshift' : 'push' ](data), notice || dequeue()
); }

var dequeue = function () { return (
  (notice = store.shift()), notice && set(notice).then(dequeue)
); }

var set = function (notice) { return new Promise(function (resolve, reject) { return show(resolve, reject, notice); }); }

var show = function (resolve, reject, notice) {
  notices.innerHTML = notice
  document.documentElement.classList.add('notices-open')
  var duration = /icon/.test(notice) ? 6000 : 4000
  setTimeout(hide, duration, resolve, reject, notice)
}

var hide = function (resolve, reject, notice) {
  document.documentElement.classList.remove('notices-open')
  wait(resolve)
}

var exclude = function () { return excludes.some(function (i) { return location.pathname.includes(i); }); }
var wait = function (resolve) { return setTimeout(exclude() ? wait : resolve, 500); }

var remove = function (e) {
  var current = e.target.closest('[data-notice-close]')
  if(current){
    storage.setStorage('cm-search-notice', 'hide', 'data-notice-remove')
    findNotice(false)
  }
}

var findNotice = function (show) {
  var target = document.querySelector('[data-notice-remove]')
  if(target && !show){
    target.remove()
  } else if (target && show){
    target.classList.remove('hide');
    target.classList.add('slide-in-bottom');
  }
}

var checkNoticeSetting = function () {
  if(storage.hasStorage()){
    if(!storage.getStorage('cm-search-notice')){
      findNotice(true)
    }
  }
}

document.addEventListener('click', remove)
document.addEventListener('DOMContentLoaded', checkNoticeSetting)

exports.queue = queue;
exports.warn = warn;
exports.confirm = confirm;
//# sourceMappingURL=notices.cjs.js.map
